import errorBoundary from '@ifeng-fe/errorBoundary';
import style from './index.css';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
const Title = ({ time, title, clockicon }) => {

    return (
        <div className={style.title}>
            <div className={style.clockico} style={{ backgroundImage: `url(${clockicon})` }} />
            <div className={style.timespan}>{time}</div>
            <div className={style.updatetext}>{title}</div>
        </div>
    );
};

Title.propTypes = {
    time: PropTypes.string,
    title: PropTypes.string,
    clockicon: PropTypes.string
};

export default errorBoundary(Title);
